import { DEFAULT_COUNTRY_CODE, RegistrationFlowType } from "myParkdUtils/enums";
import { FormRegistrationData } from "./validationSchemas";
import { UserRegistration } from "features/registration-v2/registrationV2Slice";
import { ActiveCountry, RegistrationCompanyData, RegistrationUserData, SupportedLocale } from "types";
import { Country } from "world-countries";


// legacy
export const isSelfEmployedFlow = (): boolean => window.location.href.includes('register-oem');

export const getRegistrationFlowTypeFromURL = (): RegistrationFlowType =>
    window.location.href.includes('/register-oem')
        ? RegistrationFlowType.OEM
        : RegistrationFlowType.TRACK_AND_TRACE;

export type RegistrationField = keyof FormRegistrationData;

export const initialFormData_TRACK_AND_TRACE: FormRegistrationData = {
    vat: '',
    companyName: '',
    addressStreet: '',
    addressNumber: '',
    addressCity: '',
    addressPostalCode: '',
    addressCountry: DEFAULT_COUNTRY_CODE,
    invoicingEmailAddress: '',
    sector: null,
    // user
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    password: '',
    // car
    numCars: '',
    vin: '',
    licensePlate: '',
    licensePlateCountryCode: DEFAULT_COUNTRY_CODE,
    telematicProvider: '',
    otherTelematicProvider: '',
    // other
    acceptedTC: false,
    mandateAcceptedByUser: false,
    paymentType: undefined
}

export const initialFormData_OEM: FormRegistrationData = {
    ...initialFormData_TRACK_AND_TRACE,
    numCars: 1,
    telematicProvider: 'GEOTAB'
}

export const initialTouchedFields: TouchedFields = {
    vat: false,
    companyName: false,
    addressStreet: false,
    addressNumber: false,
    addressCity: false,
    addressPostalCode: false,
    addressCountry: false,
    invoicingEmailAddress: false,
    sector: false,
    // user
    firstName: false,
    lastName: false,
    phoneNumber: false,
    emailAddress: false,
    password: false,
    // car
    numCars: false,
    vin: false,
    licensePlate: false,
    licensePlateCountryCode: false,
    telematicProvider: false,
    otherTelematicProvider: false,
    acceptedTC: false
}

export type TouchedFields = TouchedFieldsCompany & TouchedFieldsAccount

export type TouchedFieldsCompany = {
    vat: boolean,
    companyName: boolean,
    addressStreet: boolean,
    addressNumber: boolean,
    addressCity: boolean,
    addressPostalCode: boolean,
    addressCountry: boolean,
    invoicingEmailAddress: boolean,
    sector: boolean
}

export type TouchedFieldsAccount = {
    // user
    firstName: boolean,
    lastName: boolean,
    phoneNumber: boolean,
    emailAddress: boolean,
    password: boolean,
    // car
    numCars: boolean,
    vin: boolean,
    licensePlate: boolean,
    licensePlateCountryCode: boolean,
    telematicProvider: boolean,
    otherTelematicProvider: boolean,
    // other
    acceptedTC: boolean
}


export const mapFormDataToUserRegistration = (
    formData: FormRegistrationData,
    flowType: RegistrationFlowType,
    locale: SupportedLocale
): UserRegistration => {
    const {
        firstName, lastName, emailAddress, password, phoneNumber, acceptedTC,
        vat, companyName, addressStreet, addressNumber, addressCity, addressCountry, addressPostalCode, invoicingEmailAddress, sector,
        numCars, mandateAcceptedByUser, paymentType, telematicProvider, otherTelematicProvider
    } = formData;

    const user: RegistrationUserData = {
        givenName: firstName,
        familyName: lastName,
        email: emailAddress,
        password: password,
        phone: phoneNumber,
        locale: locale,
        checkboxAccepted: acceptedTC
    }

    const company: RegistrationCompanyData = {
        vat: vat,
        name: companyName,
        address: {
            street: addressStreet,
            number: addressNumber,
            city: addressCity,
            postalCode: addressPostalCode,
            countryCode: addressCountry
        },
        email: invoicingEmailAddress
    };

    const getVehicles = () => {
        const { vin, licensePlate, licensePlateCountryCode } = formData;
        return flowType === RegistrationFlowType.OEM
            ? [{ vin, licensePlate, countryCode: licensePlateCountryCode }]
            : undefined // TODO: what should front-end return here?
    }

    return {
        user: user,
        registrationCompany: company,
        vehicles: getVehicles(),
        numberOfCars: numCars,
        flowType: flowType,
        mandateAcceptedByUser: mandateAcceptedByUser,
        paymentType: paymentType,
        telematicProviderType: telematicProvider,
        otherTelematicProvider: otherTelematicProvider,
        sector: sector
    }
}

// todo: use substring?
export const mapUserLanguageToCountry = (userLanguage: SupportedLocale): ActiveCountry => {
    switch (userLanguage) {
        case 'nl':
            return 'NL';
        case 'nl-BE':
        case 'fr-BE':
        case 'fr':
            return 'BE';
        case 'en':
            return 'NL';
        default:
            return 'NL'; // Fallback
    }
}

export const getParam = (params: URLSearchParams, key: string): string | undefined => {
    const value = params.get(key);
    return value === null || value.trim() === '' ? undefined : value;
};